module.exports = __webpack_public_path__ + "static/img/icon_news.8934c3a0.svg";